import { css as emotionCss, Global as emotionGlobal } from '@emotion/react';
import { default as emotionStyled } from '@emotion/styled';

export const css = emotionCss;
export const Global = emotionGlobal;
export const styled = emotionStyled;
